import { render, staticRenderFns } from "./workOrdersH5.vue?vue&type=template&id=2c6650d2&scoped=true"
import script from "./workOrdersH5.vue?vue&type=script&lang=js"
export * from "./workOrdersH5.vue?vue&type=script&lang=js"
import style0 from "./workOrdersH5.vue?vue&type=style&index=0&id=2c6650d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6650d2",
  null
  
)

export default component.exports